module.exports = __webpack_public_path__ + "img/house_11.45c50a3c.jpg";